export enum IconSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
}

export enum IconName {
  Alert = 'alert',
  AlertTriangle = 'alert-triangle',
  Briefcase = 'briefcase',
  Badge = 'badge',
  Bus = 'bus',
  Calendar = 'calendar',
  Star = 'star',
  Car = 'car',
  Chat = 'chat',
  Check = 'check',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  Child = 'child',
  Clock = 'clock',
  Close = 'close',
  CriticalError = 'critical-error',
  Crown = 'crown',
  Cube = 'cube',
  Copy = 'copy',
  Dash = 'dash',
  DoubleChevronLeft = 'double-chevron-left',
  DoubleChevronRight = 'double-chevron-right',
  Edit = 'edit',
  Hotel = 'hotel',
  Info = 'info',
  Kitchen = 'kitchen',
  Luggage = 'luggage',
  More = 'more',
  Phone = 'phone',
  Plane = 'plane',
  Plus = 'plus',
  Refresh = 'refresh',
  Success = 'success',
  Search = 'search',
  Question = 'question',
  User = 'user',
  Walk = 'walk',
  Camera = 'camera',
  Lamp = 'lamp',
  Hours24 = '24-hours',
  Fire = 'fire',
  Pin = 'pin',
  Ski = 'ski',
  Russian = 'russian',
  StarEmpty = 'star-empty',
  Tent = 'tent',
  Flag = 'flag',
  MessageDots = 'message-dots',
  Menu = 'menu',
  Key = 'key',
}
